module.exports = __webpack_public_path__ + "static/media/BCT168.58461932.png";